import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function Reviews() {
  const reviews = [{
    name: 'Facundo M.',
    text: 'Me cambió la cabeza. Antes subía por subir y terminaba muerto a los 60 minutos. Ahora entiendo cuándo proyectarme y cuándo quedarme a hacer la cobertura. Gané mucha confianza en los duelos 1 vs 1.'
  }, {
    name: 'Tomás R.',
    text: 'El capítulo de toma de decisiones es oro puro. Jugaba de 3 pero me sentía perdido cuando el extremo se cerraba. Con esto aprendí a perfilarme y a leer la jugada antes de recibir. Muy recomendado.'
  }, {
    name: 'Julián S.',
    text: 'Lo que más me sirvió fue entender cómo generar superioridad numérica. Mis centros mejoraron un montón porque ahora levanto la cabeza y elijo el tipo de centro. Vale cada peso.'
  }];
  return <section className="py-16 px-4 bg-white" data-id="element-125">
      <div className="max-w-5xl mx-auto" data-id="element-126">
        <div className="grid md:grid-cols-3 gap-6" data-id="element-127">
          {reviews.map((review, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className="bg-[#f8f9fa] p-6 rounded-xl border border-gray-100 shadow-sm" data-id="element-128">
              <div className="flex text-[#84cc16] mb-4" data-id="element-129">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-current" data-id="element-130" />)}
              </div>
              <p className="text-gray-700 italic mb-4" data-id="element-131">"{review.text}"</p>
              <p className="font-bold text-[#1a3d1f]" data-id="element-132">{review.name}</p>
              <p className="text-sm text-gray-500" data-id="element-133">Lateral Amateur</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}